export default __webpack_public_path__ + "static/media/4_crateOfGems.fe6f14aa.png";